import React from 'react';
import { NeuroMessage, useProduct } from '@ignitesales/neuro-application/src/neuro-guide';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';

const Product = ({ isDetailsPage, product, onClick }) => {
  const {
    descriptionAbbreviated,
    disclosures,
    features,
    isSelected,
    name,
    onProductActionClick,
    onSelectClick,
    url
  } = useProduct(product);

  const cssBEM = 'product';
  const messageContext = useNeuroMessages();
  const productAction = messageContext.getMessage(`${product.id}.action.type`);
  const openAccountActionType = messageContext.getMessage('product.actionType.openAccount');
  const openTerafinaActionType = messageContext.getMessage('product.actionType.openTerafina');
  const upStartActionType = messageContext.getMessage('product.actionType.upStart');
  const contactUsActionType = messageContext.getMessage('product.actionType.contactUs');
  const enrollOnlineActionType = messageContext.getMessage('product.actionType.enrollOnline');
  const getTheAppActionType = messageContext.getMessage('product.actionType.getTheApp');

  const learnMoreClicked = () => onProductActionClick({ actionName:'productDetailsClicked', value:'learnMore'});

  const renderProductFeatures = () => {
    return (
      features.length > 0 && (
        <Collapsible
          classParentString='collapsible'
          className={'productFeatures__collapsible'}
          openedClassName={'productFeatures__collapsible--open'}
          contentInnerClassName="collapsible__content"
          open={ isDetailsPage }
          trigger={
            <div className={`${cssBEM}__features`}><NeuroMessage id='products.features.title' tagName='div' className='productFeatures__title' /></div>
          }>
          <div className={`${cssBEM}__features`}><ul>{features.map( (f,i) => <li key={i}>{f}</li>)}</ul></div>
        </Collapsible>
      )
    );
  };

  const renderProductDisclosures = () => {
    return(
      disclosures.length > 0 && (
        <Collapsible
          classParentString='collapsible'
          className={'productDisclosures__collapsible'}
          openedClassName={'productDisclosures__collapsible--open'}
          contentInnerClassName="collapsible__content"
          open={ isDetailsPage }
          trigger={
            <NeuroMessage id='products.disclosures.title'  tagName='div' className='productDisclosures__title' />
          }>
          <div className={`${cssBEM}__disclosures`}><ul>{disclosures.map( (f,i) => <li key={i}>{f}</li>)}</ul></div>
        </Collapsible>
      )
    );
  };

  const onProductClick = () => {
    onProductActionClick({
      actionName: 'productApplyClicked'
    });
    onClick({
      productId: product.id,
      productAction: productAction,
    });
  }

  const productButtonText = () => {
    switch(productAction) {
      case openAccountActionType:
        return 'product.actionButton.openAccount';
      case enrollOnlineActionType:
        return 'product.actionButton.enrollOnline';
      case getTheAppActionType:
        return 'product.actionButton.getTheApp';
      case contactUsActionType:
      default:
        return 'product.actionButton.contactUs';
    }
  }

  const renderProductButton = () => {
    return productAction && <button
      onClick={ onProductClick }>
      <NeuroMessage id={ `${productButtonText()}` } />
    </button>
  };

  const renderCartButtons = () => {
    return productAction && 
        isSelected ? 
        <button onClick={ onSelectClick } className={`${cssBEM}__cartButton remove`}>
          <NeuroMessage id='cart.remove' />
        </button>
        :
        <button onClick={ onSelectClick } className={`${cssBEM}__cartButton`}>
          <NeuroMessage id='cart.add' />
        </button>
      ;
  };

  return <div className={`${cssBEM} ${product.groupType}`} key={product.id}>
    <div className={`${cssBEM}__label`}><h5>{ product.groupType }</h5></div>
    <div className={`${cssBEM}__header`}><h1>{ name }</h1></div>
    <div className={`${cssBEM}__description`}>
      <p>
        { descriptionAbbreviated }
        { url ? <span className={`${cssBEM}__url`} onClick={learnMoreClicked}><a href={url} target="_blank" rel="noopener noreferrer">Learn More</a></span> : null }
      </p>
    </div>

      { renderProductFeatures() }

    <div className={`${cssBEM}__disclosures`}>
      {renderProductDisclosures()}
    </div>
    { renderCartButtons() }
  </div>;
};

Product.propTypes = {
  product: PropTypes.object.isRequired,
  isDetailsPage: PropTypes.object.bool
};

export default Product;
